export default {
    install(Vue)  {
        Vue.prototype.$showMaskPDF = function(pdfSrc) {
            let _this = this;
            _this.$store.state.maskPDF = true;
            _this.$store.state.pdfSrc = pdfSrc;
        };
    }
}
